export const ClaimReportHeaders = [
  'Date',
  'Provider',
  'Site',
  'Type',
  'Tariffs',
  'Status',
  'Patient',
  'Payor',
  'Total',
];

export const TariffReportHeaders = [
  'Date',
  'Code',
  'Rate',
  'Provider',
  'Site',
  'Patient',
  'Submission',
];

export const IncomeReportHeaders = [
  'Service Date',
  'Payment Date',
  'EOB',
  'Patient',
  'Tariff',
  'Billed',
  'Paid',
  'Claim #',
];

export const RejectedBillingReportHeaders = [
  'Service Date',
  'Payment Date',
  'Payor',
  'EOB',
  'Patient',
  'Tariff',
  'Requested Amount',
  'Claim #',
];

export const DelayedBillingReportHeaders = RejectedBillingReportHeaders.filter(
  (h) => h !== 'Payment Date'
);

// omit 'Description' from AuditReportHeaders until we have a better description solution
export const AuditReportHeaders = [
  'Date',
  'User',
  'Request Path',
  'Request Method',
  'IP Address',
  // 'Description',
  'Response Code',
];

export const AccountsReceivableReportHeaders = [
  'Service Date',
  'PHIN',
  'Tariff',
  'Amount Requested',
  'Amount Paid',
  'Status',
];

export const TariffProviderReportHeaders = [
  'Tariff',
  '# of Claims',
  '% of Claims',
  'Quantity (# Units)',
  '% of Units',
  'Billed',
  'Paid',
  'Outstanding',
  '% Paid',
];
